import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import classes from './ControlButton.module.scss';

const ControlButton = ({ title, className, children }) => {
  return (
    <Tippy
      content={title}
      arrow={false}
      offset={[0, 1]}
      theme="small"     
    >
      <h3 className={classes.controlButton}>
        {children}
      </h3>
    </Tippy>
  );
};

export default ControlButton;
